import React, { useState } from "react";
import { Link } from "react-router-dom";

import authService from "../../utils/services/authService";
import logo from "../../assets/images/Jobal.svg";
import styles from "./navbar.module.scss";

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const userData = authService.getUserData();
  const handleNavToggle = () => {
    setIsNavOpen((previsNavOpen) => !previsNavOpen);
  };

  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.logo}>
          <Link to="/">
            <img src={logo} alt="Jobal logo" />
          </Link>
        </div>
        <div className={styles.right}>
          <Link to="/register" className={styles.menuLink}>
            <span className={styles.menuLink_content}>Register</span>
          </Link>
          <Link to="/login" className={styles.menuLink}>
            <span className={styles.menuLink_content}>Login</span>
          </Link>

          <div className={styles.hamburger} onClick={handleNavToggle}>
            <span
              className={`${styles.hamburger_lines} ${
                isNavOpen ? styles.open : ""
              }`}
            ></span>
          </div>
        </div>
      </nav>
      <nav className={`${styles.sideNav} ${isNavOpen ? styles.open : ""}`}>
        <div className={styles.hamburgerWrapper}>
          <div className={styles.hamburger} onClick={handleNavToggle}>
            <span
              className={`${styles.hamburger_lines} ${
                isNavOpen ? styles.open : ""
              }`}
            ></span>
          </div>
        </div>
        <div className={styles.links}>
          {userData ? (
            <>
              {userData.role === "developer" &&
                userData.createdProfile === true && (
                  <Link
                    to={`/profile/developer/${userData.userId}`}
                    className={styles.menuLink}
                  >
                    <span className={styles.menuLink_content}>Profile</span>
                  </Link>
                )}
              {userData.role === "developer" && !userData.createdProfile && (
                <Link
                  to={`/profile/developer/update`}
                  className={styles.menuLink}
                >
                  <span className={styles.menuLink_content}>
                    Update profile
                  </span>
                </Link>
              )}

              {userData.role === "company" && userData.createdProfile === true && (
                <Link
                  to={`/profile/company/${userData.userId}`}
                  className={styles.menuLink}
                >
                  <span className={styles.menuLink_content}>Profile</span>
                </Link>
              )}
              {userData.role === "company" && !userData.createdProfile && (
                <Link
                  to={`/profile/company/update`}
                  className={styles.menuLink}
                >
                  <span className={styles.menuLink_content}>
                    Update profile
                  </span>
                </Link>
              )}
              {userData.role === "admin" && (
                <Link to={`/admin/dashboard`} className={styles.menuLink}>
                  <span className={styles.menuLink_content}>Profile</span>
                </Link>
              )}
            </>
          ) : (
            <>
              <Link to="/register" className={styles.menuLink}>
                <span className={styles.menuLink_content}>Register</span>
              </Link>
              <Link to="/login" className={styles.menuLink}>
                <span className={styles.menuLink_content}>Login</span>
              </Link>
            </>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
